{
    "tasks__search_placeholder": "Search tasks content",
    "tasks_overview_table__header__title": "Task",
    "tasks_overview_table__header__due_date": "Due Date",
    "tasks_overview_table__header__completed_at": "Completed at",
    "tasks_overview_table__header__related_to": "Related To",
    "tasks_overview_table__header__assigned_to_user": "Assignee",
    "tasks_overview_table__header__assigned_by_user": "Created by",
    "tasks_overview_table__attachments_count_aria_one": "View {{count}} attachment",
    "tasks_overview_table__attachments_count_aria_other": "View {{count}} attachments",
    "filter_menu_title__customers": "Customers",
    "filter_menu_title__orders": "Orders",
    "filter_menu_title__quotes": "Quotes",
    "filter_menu_title__assigned_tos": "Assignee",
    "filter_menu_title__assigned_bys": "Created by",
    "tasks__group_today": "Today",
    "tasks__group_upcoming": "Upcoming",
    "tasks__group_completed": "Completed",
    "tasks__quick_filters__to_me": "Assigned to me",
    "tasks__quick_filters__by_me": "Assigned by me",
    "tasks__empty_state__body": "No tasks to see here. Use tasks to delegate work to colleagues or set yourself a reminder.",
    "tasks__empty_state__create_task": "Create new task",
    "task_overview_table__options_aria": "Task options",
    "task_overview_table__options__edit_task": "Edit task",
    "task_overview_table__options__delete_task": "Delete task",
    "tasks__delete_confirmation__title": "Delete task",
    "tasks__delete_confirmation__body": "The task will be deleted permanently. This action cannot be undone.",
    "tasks__assigned_to_placeholder": "Select a user",
    "tasks__assigned_to_placeholder_multiple": "Select users (multiple possible)",
    "tasks_open_tasks": "Open Tasks",
    "overdue": "Overdue",
    "due_today": "Due today",
    "details__title": "Task",
    "tasks__form_create_title": "Create task",
    "tasks__form_edit_title": "Task",
    "tasks__form_create_submit_zero": "Create task",
    "tasks__form_create_submit_one": "Create task",
    "tasks__form_create_submit_other": "Create {{count}} tasks",
    "tasks__description_placeholder": "Enter task details",
    "tasks__toast__created_one": "Task created successfully",
    "tasks__toast__created_other": "{{count}} tasks created successfully",
    "tasks__toast__edited_success_title": "Task edited successfully",
    "tasks__toast__success_body": "You can view it <linkTag>here</linkTag>",
    "tasks__toast__deleted_success_title": "Task deleted succesfully",
    "tasks__entity_search__placeholder": "Search for customer, order or quote",
    "form__complete_task": "Mark as completed",
    "form__open_task": "Reopen task",
    "tasks__form__created_by_label": "Created by",
    "tasks__form__download_file": "Download",
    "tasks__form__download_error": "Failed to download file",
    "tasks__form__edit_file": "Edit",
    "tasks__form__delete_attachment_confirmation__title": "Delete attachment",
    "tasks__form__delete_attachment_confirmation__body": "The attachment will be removed. This action cannot be undone.",
    "task_not_found": "Task not found",
    "status_OPEN": "Open",
    "status_COMPLETED": "Completed",
    "comments__section_title": "Activity",
    "comments__add_placeholder": "Add a comment...",
    "comments__save": "Save",
    "comments__edit": "Edit",
    "comments__delete": "Delete",
    "comments__edited": "(edited)",
    "comments__delete_confirmation__title": "Delete comment",
    "comments__delete_confirmation__body": "The comment will be deleted permanently. This action cannot be undone.",
    "comments__toast__deleted_success_title": "Comment deleted successfully",
    "comments__toast__updated_success_title": "Comment updated successfully",
    "table_header__task": "Task",
    "task_column__create_task_tooltip": "Create task",
    "task_column__tasks_count_one": "{{count}} task",
    "task_column__tasks_count_other": "{{count}} tasks"
}
